import { inject, Injectable } from "@angular/core";
import { AppConfigService } from "@app/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslocoService } from "@ngneat/transloco";
import { EMPTY, from, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ConfirmationModalComponent } from "ui-kit";

@Injectable({ providedIn: "root" })
export class PosDisconnectConfirmationService {
  private readonly modalService = inject(NgbModal);
  private readonly transloco = inject(TranslocoService);
  private readonly appConfig = inject(AppConfigService);

  confirm(name: string): Observable<void> {
    const modal = this.modalService.open(ConfirmationModalComponent, {
      backdrop: "static",
      size: "md",
      centered: true,
      windowClass: "custom confirm"
    });
    const confirmation: ConfirmationModalComponent = modal.componentInstance;
    confirmation.title = this.transloco.translate("posMarketplace.connection.disconnect.confirmTitle", { name });
    confirmation.message = this.transloco.translate("posMarketplace.connection.disconnect.confirmMessage", {
      name,
      appName: this.appConfig.appData.title
    });
    confirmation.confirmBtnText = "posMarketplace.connection.disconnect.confirm";
    confirmation.icon = "mdi-link-variant-off";
    confirmation.tone = "danger";

    return from(modal.result).pipe(
      map(() => undefined),
      catchError(() => EMPTY)
    );
  }
}
